import produce from 'immer';
import { handleActions } from 'redux-actions';
import actions from './actions';
import {
  SEARCH_WORD_LIST_SEARCH_DATA_MODEL,
  SEARCH_WORD_LIST_SEARCH_OPTION_MODEL,
  SEARCH_WORD_LIST_SORT_OPTION_MODEL,
  SEARCH_WORD_SAVE_MODEL,
} from './models';
import { updateStoreWithPath } from '../../../lib/common';
import { _LIST_PAGINATION_MODEL } from '../app/models';

/**
 *  INITIAL STATE
 */
const initialState = {
  /**
   *  검색 키워드 리스트
   */
  searchWordList: {
    /**
     *  리스트
     */
    list: [],
    /**
     *  검색 박스
     */
    searchData: SEARCH_WORD_LIST_SEARCH_DATA_MODEL,
    /**
     *  검색 옵션
     */
    searchOption: SEARCH_WORD_LIST_SEARCH_OPTION_MODEL,
    /**
     *  정렬 옵션
     */
    sortOption: SEARCH_WORD_LIST_SORT_OPTION_MODEL,
    /**
     *  리스트 pagination
     */
    pagination: _LIST_PAGINATION_MODEL,
  },

  /**
   *  검색 키워드 등록/편집
   */
  searchWordSave: SEARCH_WORD_SAVE_MODEL,
};

/**
 *  REDUCER
 */
export default handleActions(
  {
    /**
     *  데이터 변경하기
     */
    [actions.SET_DATA]: (state, action) => {
      return produce(state, (draft) => {
        updateStoreWithPath(action.payload.path, action.payload.value, draft);
      });
    },

    /**
     *  [검색 키워드 리스트] 검색 키워드 리스트 가져오기
     */
    [actions.GET_SEARCH_WORD_LIST_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        draft.searchWordList = {
          ...draft.searchWordList,
          ...action.payload.searchWordList,
        };
      });
    },

    /**
     *  검색 키워드 상세 요청하기
     */
    [actions.GET_SEARCH_WORD_DETAIL_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        draft.searchWordSave = action.payload.searchWordSave;
      });
    },

    /**
     *  키워드 체크하기
     */
    [actions.CHECK_KEYWORD_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        draft.searchWordSave.isDuplicateWord = action.payload.searchWordSave.isDuplicateWord;
      });
    },

    /**
     *  연관 키워드 리스트 요청하기
     */
    [actions.GET_RELATED_SEARCH_WORD_LIST_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        draft.searchWordSave.relatedKeywordSelectList = action.payload.relatedKeywordSelectList;
      });
    },
  },
  initialState,
);
